// User-set difficulty offset, applied to a session's exercise
// list so the player engine sees pre-tuned hold/relax/sec values.
//
// Three settings:
//   -1 = "easier"   (hold/relax/sec scaled to 80%)
//    0 = "standard" (no change)
//   +1 = "stronger" (scaled to 120%)
//
// Pulse counts (`sets`, `reps`) are NOT scaled — increasing the
// number of reps changes the character of the exercise. We only
// scale the *durations* so the floor works at the user's feel.
//
// Applied at SessionScreen load (before exercises reach
// RingPlayer); the engine itself stays oblivious. Pre-defined
// exercise objects are immutable, so we deep-clone the fields
// we change.

const SCALE_BY_OFFSET = { '-1': 0.8, 0: 1, 1: 1.2 };

const SCALABLE_FIELDS = ['hold', 'relax', 'sec', 'rest'];

export function difficultyScale(offset) {
  return SCALE_BY_OFFSET[String(offset)] ?? 1;
}

export function applyDifficulty(exercises, offset) {
  if (!Array.isArray(exercises)) return exercises;
  const scale = difficultyScale(offset);
  if (scale === 1) return exercises;
  return exercises.map((ex) => {
    if (!ex || typeof ex !== 'object') return ex;
    const out = { ...ex };
    for (const key of SCALABLE_FIELDS) {
      const v = out[key];
      if (typeof v === 'number' && v > 0) {
        // Round to whole seconds — the engine uses integer
        // countdowns, and fractional values would break the tick
        // logic. Floor for safety on the easier side, ceiling on
        // stronger so the user always feels the bump.
        out[key] = scale < 1 ? Math.max(1, Math.floor(v * scale)) : Math.ceil(v * scale);
      }
    }
    return out;
  });
}

// String key for the user-visible label of each setting.
export function difficultyLabelKey(offset) {
  if (offset === -1) return 'difficulty_easier';
  if (offset === 1)  return 'difficulty_stronger';
  return 'difficulty_standard';
}
